// import ModalForm from "./Form";
import PlacementRecommendTableForm from "./PlacementRecommendTableForm";
import {
    DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";
import { isNull } from "lodash";
import {urlGenerator} from "../../../../../../../Helpers/AxiosHelper";

export const PlacementRecommendTableSchema = {
    props: ["isView"],
    components: { PlacementRecommendTableForm },

    data() { 
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: "",
            Endpoint:  "transaction/placement/getRecommendClass" ,
            tableId: "placement-recommend-table",
            formId: "placement-recommend-table-form",
            rowData: {},
            tableColumns: [
                {
                    title: "Semester",
                    type: "custom-html",
                    key: "academic_calendar",
                    modifier: (value) => {
                        return isNull(value) ? "" : value.academic_calendar_name;
                    },
                },
                {
                    title: "Product Name",
                    type: "custom-html",
                    key: "product",
                    modifier: (value) => {
                        return isNull(value) ? "" : value.name;
                    },
                },
                {
                    title: "Package Name",
                    type: "text",
                    key: "package_name"
                },
                {
                    title: "Monday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const monday = children.find(c => c.start_time_1 || c.end_time_1);
                        if (!monday) return "";
                        const start = monday.start_time_1?.slice(0, 5) || "";
                        const end = monday.end_time_1?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Tuesday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const tuesday = children.find(c => c.start_time_2 || c.end_time_2);
                        if (!tuesday) return "";
                        const start = tuesday.start_time_2?.slice(0, 5) || "";
                        const end = tuesday.end_time_2?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Wednesday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const wed = children.find(c => c.start_time_3 || c.end_time_3);
                        if (!wed) return "";
                        const start = wed.start_time_3?.slice(0, 5) || "";
                        const end = wed.end_time_3?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Thursday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const thu = children.find(c => c.start_time_4 || c.end_time_4);
                        if (!thu) return "";
                        const start = thu.start_time_4?.slice(0, 5) || "";
                        const end = thu.end_time_4?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Friday",
                    type: "custom-html",
                    key: "child",
                    modifier: (children) => {
                        if (!Array.isArray(children)) return "";
                        const fri = children.find(c => c.start_time_5 || c.end_time_5);
                        if (!fri) return "";
                        const start = fri.start_time_5?.slice(0, 5) || "";
                        const end = fri.end_time_5?.slice(0, 5) || "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Start Date",
                    type: "text",
                    key: "clc_start_date",
                },
                {
                    title: "Due Date",
                    type: "text",
                    key: "due_date",
                },
                {
                    title: "Invoice Type",
                    type: "text",
                    key: "invoice_type",
                },
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "PlacementRecommendTable",
                url: "transaction/placement/getRecommendClass?placement_id=" + this.placementId,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                    	title: this.$t("edit"),
                    	icon: "edit",
                    	type: "none",
                    	component: "placement-recommend-table-form",
                    	modalId: "placement-recommend-table-form",
                    },
                    {
                        title: this.$t("delete"),
                        icon: "trash",
                        type: "none",
                        component: "app-confirmation-modal",
                        modalId: "demo-delete",
                    },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 3,
                showAction: !this.isView,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {},
};
